import React from "react";
import Hero from "./Hero";
import HeroServices from "./HeroServices";
import PopularTile from "../../components/Tiles/PopularTile";
import HeroTestimonials from "./HeroTestimonials";
import NigeriaMap from "../../components/Tiles/NigeriaMap";
import CallToActionSection from "../../components/Others/CallToActionSection";
import ClientStrategy from "../../components/Others/ClientStrategy";
import BookAdsSection from "../../components/Others/BookAdsSection";


const LandingPage = () => {
  return (
    <div className="overflow-hidden">
      <Hero />
      <HeroServices />
      <PopularTile />
      <CallToActionSection />
      <BookAdsSection />
      <NigeriaMap />
      <HeroTestimonials />
      <ClientStrategy />
    </div>
  );
};

export default LandingPage;
